export enum colors {
  YELLOW = '#ff9e18',
  BLUE = '#0071ce',
  LIGHT_BLUE = '#F8F9FF',
  PINK = '#ff5100',
  GREEN = '#00b189',
  VIOLET = '#9013FE'
}
